import { ExternalLink } from 'lucide-react';

interface LinkFieldCellProps {
  url: string;
}

/** Backend nie gwarantuje poprawnego adresu — przy błędnym pokazujemy go w całości. */
const hostOf = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
};

export const LinkFieldCell = ({ url }: LinkFieldCellProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={`Otwórz link: ${url}`}
      aria-label={`Otwórz link: ${url}`}
      className="group/link inline-flex max-w-full items-center gap-1.5 text-left"
    >
      <ExternalLink
        className="size-3.5 shrink-0 text-neutral-500"
        aria-hidden
      />
      <span className="truncate font-semibold text-base-text group-hover/link:underline">
        {hostOf(url)}
      </span>
    </button>
  );
};
